import { Injectable } from '@angular/core';
import { ProductCategoryEnum } from '@mwe/constants';
import { getProductCategoryEnum, isString } from '@mwe/utils';
import { Product } from '@mwe/models';

@Injectable({ providedIn: 'root' })
export class ProductsWhiteListLogic {
  private productsCategoryWhiteList: ProductCategoryEnum[] = [
    ProductCategoryEnum.STROM,
    ProductCategoryEnum.NACHTSTROM,
    ProductCategoryEnum.STROMRUECK,
    ProductCategoryEnum.GAS,
    ProductCategoryEnum.FERNWAERME,
    ProductCategoryEnum.EMOBILITY,
    ProductCategoryEnum.INTERNET,
    ProductCategoryEnum.IPTV,
    ProductCategoryEnum['MOBILES INTERNET'],
    ProductCategoryEnum.VOIP,
  ];

  setWhiteList(whiteList: ProductCategoryEnum[]): void {
    this.productsCategoryWhiteList = whiteList;
  }

  isInWhiteList(category: string | ProductCategoryEnum): boolean {
    const categoryEnum = isString(category) ? getProductCategoryEnum(category as string) : (category as ProductCategoryEnum);
    return this.productsCategoryWhiteList.some(productCategory => productCategory === categoryEnum);
  }

  areSomeInWhiteList(products: Product[]): boolean {
    return products.some(product => {
      return this.isInWhiteList(product.category);
    });
  }

  areAllNotInWhiteList(products: Product[]): boolean {
    return !this.areSomeInWhiteList(products);
  }

  removeNotWhiteListedProducts(products: Product[]): Product[] {
    if (!Array.isArray(products)) {
      return [];
    }

    return products.filter(product => this.isInWhiteList(product.category));
  }
}
